import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17ec0b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting" }
const _hoisted_2 = { class: "color" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "color__title" }, "Post Color", -1))
const _hoisted_4 = { class: "color__section" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"font-size":"0.8rem"} }

import { ActionTypes } from "@/store/actions";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const colors = [
  { color: "#FEC0CA", name: "Pink" },
  { color: "#2dfff1", name: "Mint" },
  { color: "#96d5ff", name: "Skyblue" },
  { color: "#f2f486", name: "Yellow" },
  { color: "#F5F5F6", name: "White" },
  { color: "#a5ffb9", name: "Green" },
  { color: "#DAC6AE", name: "Beige" },
  { color: "#ff7d3d", name: "Orange" },
];
function selectPostColor(color: string) {
  localStorage.setItem("post_color", color);
  store.dispatch(ActionTypes.GET_POSTCOLOR);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (color, i) => {
          return _createElementVNode("div", {
            class: "color__btn",
            key: i,
            onClick: ($event: any) => (selectPostColor(color.color))
          }, [
            _createElementVNode("div", {
              class: "color__circle",
              style: _normalizeStyle({ backgroundColor: color.color })
            }, null, 4),
            _createElementVNode("p", _hoisted_6, _toDisplayString(color.name), 1)
          ], 8, _hoisted_5)
        }), 64))
      ])
    ])
  ]))
}
}

})